module.exports = __webpack_public_path__ + "static/img/BANNER111.b96fba5.png";


//////////////////
// WEBPACK FOOTER
// ./static/BANNER111.png
// module id = Gwkm
// module chunks = 1